/* eslint-disable @typescript-eslint/no-explicit-any */
import FullPageLayout from "../../../../templates/FullPageLayout";
import {
  Button,
  Col,
  Row,
  Card,
  Form,
  Switch,
  Checkbox,
  Radio,
  RadioChangeEvent,
  Calendar,
  Flex,
  Select,
  Tooltip,
} from "antd";
import { Controller, useForm } from "react-hook-form";
import {
  FlagFilledIcon,
  InfoIconOutlined,
  NeedHelp,
  SelectArrow,
} from "../../../../atoms/CustomIcons";
import { useEffect, useState } from "react";
import {
  DateField,
  InputField,
  SelectField,
  TextEditor,
} from "../../../../atoms/FormFields";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../../config/hooks";
import UploadFullMultiple from "../../../../atoms/UploadPhoto/UploadFullMultiple";
import { createTask, uploadUserImageBulk } from "../../ducks/services";
import { SuccessMessage } from "../../../../atoms/Toasts/SuccessMessage";
import { AxiosError, AxiosResponse } from "axios";
import { ErrorMessage } from "../../../../atoms/Toasts/ErrorMessage";
import { getTaskFormData } from "../../ducks/actions";
import { SelectedPropertyValue } from "../../ducks/types";
import dayjs, { Dayjs } from "dayjs";
import { RcFile } from "antd/es/upload";
import PlacePicker from "../../Components/Filters/PlacePicker";
import EmptyCard from "../../../../atoms/EmptyCard";

interface FormValues {
  name: string;
  file_required: boolean;
  property: string;
  priority: string;
  due_date: string;
  details: string;
  source: string;
  responsible_for_account: string;
  service: string;
}

export default function AddTask() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const location = window.location.pathname;
  const pathSegments = location.split("/");
  const companyId = pathSegments[pathSegments.length - 1];
  const [propertyDropdown, setPropertyDropdown] = useState<
    {
      label: string;
      value: string;
      contracts: any[];
      latitude?: number;
      longitude?: number;
      address: string;
    }[]
  >([]);
  const [workOrderDropdown, setWorkOrderDropdown] = useState<
    {
      label: string;
      value: string;
      service_line_name: string;
      service_line_id: string;
      service_line_color: string;
      production_manager_name: string;
      production_manager_id: string;
      production_manager_image_url: string;
    }[]
  >([]);
  const [checklistFile, setChecklistFile] = useState<File[] | null>(null);
  const [loading, setLoading] = useState(false);
  const [attachFiles, setAttachFiles] = useState(false);
  const [contractID, setContractId] = useState("");
  const [attachLocation, setAttachLocation] = useState(false);
  const [scheduleNow, setScheduleNow] = useState(false);
  const [doEveryVisit, setDoEveryVisit] = useState(false);
  const [calendarValue, setCalendarValue] = useState<Dayjs>(() => dayjs());
  const [defaultCenter, setDefaultCenter] = useState<{
    lat: number;
    lng: number;
  }>({ lat: 0, lng: 0 });
  const [propertySelectedValue, setPropertySelectedValue] =
    useState<SelectedPropertyValue | null>(null);
  const [radioValue, setRadioValue] = useState<string>("");
  const taskFormData = useAppSelector((state) => state.workOrders.taskFormData);

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValues>();

  // const [previewImage, setPreviewImage] = useState<{
  //   file: string;
  //   imagePreviewUrl: string | null;
  // }>({ file: "", imagePreviewUrl: null });
  // const [modalPreviewImage] = useState<{
  //   file: string;
  //   imagePreviewUrl: string | null;
  // }>({ file: "", imagePreviewUrl: null });

  const saveUpload = () => {
    setLoading(true);
    // setPreviewImage({ ...modalPreviewImage });
    setLoading(false);
  };

  useEffect(() => {
    if (companyId) {
      dispatch(getTaskFormData(companyId));
    }
  }, [companyId, dispatch]);

  const onSubmit = (val: FormValues) => {
    if (!contractID) {
      ErrorMessage("Please select a contract");
      return;
    }
    setLoading(true);
    // const serviceObj = taskFormData?.data?.services?.find(
    //   (item) => item?.value === val?.service
    // );
    const payload = {
      name: val?.name ?? "", // required
      company_id: companyId, // required

      do_every_visit: doEveryVisit,
      priority: val?.priority ?? "normal", // required
      due_date: val?.due_date
        ? dayjs(val?.due_date).format("YYYY-MM-DD")
        : undefined,
      details: val?.details ?? "",
      source: val?.source ?? undefined,
      proof_of_completion: val?.file_required,
      latitude: attachLocation ? defaultCenter?.lat?.toString() : undefined,
      longitude: attachLocation ? defaultCenter?.lng?.toString() : undefined,
      property_id: val?.property ?? "", // required
      scheduled_date: calendarValue
        ? dayjs(calendarValue).format("YYYY-MM-DD")
        : undefined,
      property_address: propertySelectedValue?.address ?? "",
      property_name: propertySelectedValue?.label ?? "",
      contract_id: contractID,
      contract_name:
        propertySelectedValue?.contracts?.find(
          (item) => item?.id === contractID
        )?.name ?? "",
      work_order_id: val?.service ?? "",
      work_order_name:
        workOrderDropdown?.find((item) => item.value === val?.service)?.label ??
        "",
      service_line_name:
        workOrderDropdown?.find((item) => item.value === val?.service)
          ?.service_line_name ?? "",
      service_line_id:
        workOrderDropdown?.find((item) => item.value === val?.service)
          ?.service_line_id ?? "",
      service_line_color:
        workOrderDropdown?.find((item) => item.value === val?.service)
          ?.service_line_color ?? "",
      production_manager_id:
        workOrderDropdown?.find((item) => item.value === val?.service)
          ?.production_manager_id ?? "",
      production_manager_image_url:
        workOrderDropdown?.find((item) => item.value === val?.service)
          ?.production_manager_image_url ?? "",
      production_manager_name:
        workOrderDropdown?.find((item) => item.value === val?.service)
          ?.production_manager_name ?? "",
    };

    createTask(payload)
      .then((res: AxiosResponse) => {
        if (checklistFile && res && res?.data?.id) {
          uploadUserImageBulk({
            owner_id: res?.data?.id,
            image: checklistFile as File[] | RcFile[],
            image_type: "task_work_files",
          })
            .then((res) => {
              if (res) {
                setLoading(false);
                SuccessMessage("Task added");
                navigate(`/tasks/${companyId}`);
              }
            })
            .catch((e: unknown) => {
              if (e instanceof AxiosError) {
                setLoading(false);
                ErrorMessage(
                  e?.response?.data?.error?.message ?? "Something went wrong"
                );
              } else {
                setLoading(false);
                ErrorMessage("Something went wrong");
              }
            });
        } else {
          setLoading(false);
          SuccessMessage("Task added");
          navigate(`/tasks/${companyId}`);
        }
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          setLoading(false);
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
        } else {
          setLoading(false);
          ErrorMessage("Something went wrong");
        }
      });
  };

  const priorityOptions = [
    {
      label: "Urgent",
      value: "urgent",
      icon: <FlagFilledIcon style={{ color: "#D33D3D" }} />,
    },
    {
      label: "High",
      value: "high",
      icon: <FlagFilledIcon style={{ color: "#F58E45" }} />,
    },
    {
      label: "Normal",
      value: "normal",
      icon: <FlagFilledIcon style={{ color: "#2098EE" }} />,
    },
    {
      label: "Low",
      value: "low",
      icon: <FlagFilledIcon style={{ color: "#B2BDC2" }} />,
    },
  ];

  const sourceOptions = [
    {
      label: "Customer complaint",
      value: "customer_complaint",
    },
    {
      label: "Internal request",
      value: "internal_request",
    },
  ];

  const propertyChange = (value: string | number | readonly string[]) => {
    const filteredProperty = propertyDropdown?.find(
      (item: { value: string }) => item?.value === value
    );
    setAttachLocation(false);
    console.log("filteredProperty", filteredProperty);
    setPropertySelectedValue(filteredProperty ?? null);
    if (
      filteredProperty?.contracts &&
      filteredProperty?.contracts?.length > 0
    ) {
      selectContractFuncBtDefault(filteredProperty?.contracts?.[0]);
      setRadioValue(filteredProperty?.contracts?.[0]?.id);
    }
    setDefaultCenter({
      lat: Number(filteredProperty?.latitude) || 0,
      lng: Number(filteredProperty?.longitude) || 0,
    });
  };

  // Function to get the date for the next month
  // const getNextMonth = (date: Dayjs) => {
  //   return date.add(1, "month");
  // };

  // const nextMonthValue = getNextMonth(value);

  useEffect(() => {
    if (taskFormData?.data) {
      const dummyArray: {
        label: string;
        value: string;
        address: string;
        contracts: any[];
        latitude?: number;
        longitude?: number;
      }[] = [];
      taskFormData?.data?.map((item) => {
        return dummyArray.push({
          label: item?.name,
          value: item?.id,
          contracts: item?.contracts,
          latitude: item?.latitude,
          longitude: item?.longitude,
          address: item?.address,
        });
      });
      setPropertyDropdown(dummyArray);
    }
  }, [taskFormData?.data]);

  const selectContractFunc = (value: string) => {
    setContractId(value);
    const workOrders = propertySelectedValue?.contracts?.find(
      (item) => item.id === value
    )?.workOrders;
    const mappedWorkOrders =
      workOrders?.map((wo: any) => ({
        label: wo.name,
        value: wo.id,
        service_line_name: wo.service_line_name ?? "",
        service_line_id: wo.service_line_id ?? "",
        service_line_color: wo.service_line_color ?? "",
        production_manager_name: wo.production_manager_name ?? "",
        production_manager_image_url: wo.production_manager_image_url ?? "",
        production_manager_id: wo.production_manager_id ?? "",
      })) ?? [];
    setWorkOrderDropdown(mappedWorkOrders);
  };

  const selectContractFuncBtDefault = (value: any) => {
    setContractId(value.id);
    const workOrders = value?.workOrders;
    const mappedWorkOrders =
      workOrders?.map((wo: any) => ({
        label: wo.name,
        value: wo.id,
        service_line_name: wo.service_line_name ?? "",
        service_line_id: wo.service_line_id ?? "",
        service_line_color: wo.service_line_color ?? "",
        production_manager_name: wo.production_manager_name ?? "",
        production_manager_image_url: wo.production_manager_image_url ?? "",
        production_manager_id: wo.production_manager_id ?? "",
      })) ?? [];
    setWorkOrderDropdown(mappedWorkOrders);
  };

  // useEffect(() => {
  //   if (
  //     propertySelectedValue?.contracts &&
  //     propertySelectedValue?.contracts?.length > 1
  //   ) {
  //     selectContractFunc(propertySelectedValue?.contracts?.[0]?.id);
  //     setRadioValue(propertySelectedValue?.contracts?.[0]?.id);
  //   }
  // }, [propertySelectedValue?.contracts]);

  return (
    <FullPageLayout loading={loading || taskFormData?.loader}>
      <Form
        className="propertyForm"
        layout="vertical"
        onFinish={handleSubmit(onSubmit)}
        onKeyDown={(e) => {
          if (e.key === "Enter") e.preventDefault();
        }}
      >
        <Button className="btn-sm fixedTopBtn">
          <NeedHelp /> Need help?
        </Button>

        <div style={{ paddingBottom: 80 }}>
          <Row gutter={8} style={{ width: "672px" }}>
            <Col span={24}>
              <div
                className="title"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                }}
              >
                <div>
                  <h2> New task </h2>
                  <p>
                    Additional work item to a regular service, which crews can
                    take care of.
                  </p>
                </div>
              </div>
            </Col>

            <Col span={24}>
              <Card>
                <Row gutter={20}>
                  <Col span={24}>
                    <InputField
                      fieldName="name"
                      label="Task name"
                      control={control}
                      className="task_name_input"
                      defaultValue=""
                      iProps={{
                        placeholder: "Enter task name...",
                      }}
                      isRequired
                      rules={{
                        required: "Task name is required.",
                      }}
                      validate={errors.name && "error"}
                      validMessage={errors.name && errors.name.message}
                    />
                  </Col>
                  <Col span={24}>
                    <SelectField
                      fieldName="property"
                      label="Property"
                      control={control}
                      selectOption={propertyDropdown ?? []}
                      iProps={{
                        placeholder: "Select property",
                      }}
                      isRequired
                      rules={{
                        required: "Property is required.",
                      }}
                      validate={errors.property && "error"}
                      validMessage={errors.property && errors.property.message}
                      tooltipTitle="Select property"
                      onSelectChange={(value) => propertyChange(value)}
                    />
                  </Col>
                  {propertySelectedValue && (
                    <>
                      {propertySelectedValue?.contracts &&
                      propertySelectedValue?.contracts?.length > 0 ? (
                        <Col span={24}>
                          <Card className="task_contract_card">
                            <Radio.Group
                              size="large"
                              className="task_radio_wrapper"
                              onChange={(e: RadioChangeEvent) => {
                                selectContractFunc(e.target.value);
                                setRadioValue(e.target.value);
                              }}
                              value={radioValue}
                            >
                              <Row gutter={[8, 8]}>
                                {propertySelectedValue?.contracts?.map(
                                  (contract) => (
                                    <Col
                                      span={
                                        propertySelectedValue?.contracts &&
                                        propertySelectedValue?.contracts
                                          ?.length > 1
                                          ? 12
                                          : 24
                                      }
                                      key={contract.id}
                                    >
                                      <Radio.Button
                                        value={contract.id}
                                        className="task_radio_card"
                                      >
                                        <div className="card_wrapper">
                                          <div className="label">Contract</div>
                                          <div className="contract_value">
                                            {contract.name}
                                          </div>
                                        </div>
                                        <div className="card_wrapper">
                                          <div className="label">Dates</div>
                                          <div className="contract_value">
                                            {dayjs(contract.start_date).format(
                                              "ll"
                                            )}{" "}
                                            -{" "}
                                            {dayjs(contract.end_date).format(
                                              "ll"
                                            )}
                                          </div>
                                        </div>
                                      </Radio.Button>
                                    </Col>
                                  )
                                )}
                              </Row>
                            </Radio.Group>

                            <Row gutter={8}>
                              <Col flex="auto">
                                <SelectField
                                  fieldName="service"
                                  label="Work order"
                                  control={control}
                                  selectOption={workOrderDropdown ?? []}
                                  iProps={{
                                    placeholder: "Select work order",
                                  }}
                                  isRequired
                                  rules={{
                                    required: "Work order is required.",
                                  }}
                                  validate={errors.service && "error"}
                                  validMessage={
                                    errors.service && errors.service.message
                                  }
                                  tooltipTitle="Select work order"
                                />
                              </Col>
                              <Col flex="165px" style={{ marginTop: "30px" }}>
                                <div
                                  className="switchBox"
                                  style={{ gap: "8px", fontSize: "13px" }}
                                >
                                  <Switch
                                    checked={doEveryVisit}
                                    onChange={setDoEveryVisit}
                                  />
                                  Do every visit
                                  <Tooltip title="Do every visit">
                                    <InfoIconOutlined
                                      style={{ opacity: "0.4" }}
                                    />
                                  </Tooltip>
                                </div>
                              </Col>
                            </Row>
                          </Card>
                        </Col>
                      ) : (
                        <Card className="empty_wrap_card">
                          <EmptyCard
                            imageHeight={87}
                            title="No active contract"
                            description="The task cannot be created as the property lacks a contract."
                            image="/images/empty-icons/no-active-contract.svg"
                          />
                        </Card>
                      )}
                    </>
                  )}
                  <Col span={12}>
                    <SelectField
                      fieldName="priority"
                      label="Priority"
                      control={control}
                      selectOption={priorityOptions}
                      iProps={{
                        placeholder: "None",
                      }}
                      tooltipTitle="Priority"
                    />
                  </Col>
                  <Col span={12}>
                    <DateField
                      fieldName="due_date"
                      label="Due date"
                      control={control}
                    />
                  </Col>
                  <Col span={24} className="task_message">
                    <TextEditor
                      fieldName="details"
                      label="Details"
                      control={control}
                      tooltipTitle="Details tooltip"
                    />
                  </Col>
                  <Col span={24}>
                    <SelectField
                      fieldName="source"
                      label="Source"
                      control={control}
                      selectOption={sourceOptions}
                      iProps={{
                        placeholder: "Select who came up with this task",
                      }}
                    />
                  </Col>
                </Row>
              </Card>
              <Card className="switchBoxCard">
                <Row gutter={[20, 8]}>
                  <Col span={24}>
                    <div className="switchBoxBold">
                      <Switch
                        onChange={() => setAttachFiles(!attachFiles)}
                        checked={attachFiles}
                      />
                      Attach files
                    </div>
                  </Col>
                  {attachFiles && (
                    <>
                      <Col span={24}>
                        <UploadFullMultiple
                          saveUpload={saveUpload}
                          loading={false}
                          onImageDelete={() => null}
                          // previewImage={previewImage}
                          // checklistFile={checklistFile}
                          // modalPreviewImage={modalPreviewImage}
                          setChecklistFile={setChecklistFile}
                          // setPreviewImage={setPreviewImage}
                          // setModalPreviewImage={setModalPreviewImage}
                        />
                      </Col>

                      <Col span={24}>
                        <div className="probabilityTitle">
                          <span className="not_specified">
                            <Controller
                              name="file_required"
                              control={control}
                              render={({ field }) => (
                                <Checkbox
                                  {...field}
                                  checked={field.value}
                                  onChange={(e) =>
                                    field.onChange(e.target.checked)
                                  }
                                >
                                  <div
                                    className="required_text"
                                    style={{
                                      display: "flex",
                                      justifyContent: "flex-start",
                                      alignItems: "flex-start",
                                      flexDirection: "column",
                                      paddingLeft: "10px",
                                    }}
                                  >
                                    <h4
                                      style={{
                                        fontSize: "14px",
                                        lineHeight: "20px",
                                        fontWeight: "500",
                                        marginBottom: "2px",
                                      }}
                                    >
                                      Requires proof of completion
                                    </h4>
                                    <p
                                      style={{
                                        fontSize: "11px",
                                        lineHeight: "14px",
                                        fontWeight: "400",
                                        marginBottom: "0px",
                                        color: "#98A3A9",
                                      }}
                                    >
                                      The crew leader will be required to take a
                                      photo or video upon visit completion.
                                    </p>
                                  </div>
                                </Checkbox>
                              )}
                            />
                          </span>
                        </div>
                      </Col>
                    </>
                  )}
                </Row>
              </Card>

              <Card className="switchBoxCard">
                <Row gutter={20}>
                  <Col span={24}>
                    <div className="switchBoxBold">
                      <Switch
                        onChange={() => setAttachLocation(!attachLocation)}
                        checked={attachLocation}
                      />
                      Attach location
                    </div>
                  </Col>
                  {attachLocation && (
                    <Col span={24}>
                      <PlacePicker
                        defaultCenter={defaultCenter}
                        hideSearch={true}
                      />
                    </Col>
                  )}
                </Row>
              </Card>

              <Card className="switchBoxCard" style={{ display: "none" }}>
                <div className="switchBoxBold">
                  <Switch
                    onChange={() => setScheduleNow(!scheduleNow)}
                    checked={scheduleNow}
                  />
                  Schedule now
                </div>
                <p style={{ marginBottom: "8px" }}>
                  Select a day with a scheduled visit. The task will be added to
                  that visit.
                </p>

                {scheduleNow && (
                  <div
                    style={{
                      padding: "0px",
                      backgroundColor: "#fff",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "16px",
                    }}
                  >
                    <Card
                      bordered={false}
                      style={{
                        borderRadius: "16px",
                        border: "1px solid #EFF2F3",
                      }}
                    >
                      <Row gutter={[16, 16]}>
                        <Col xs={24} md={24}>
                          <Calendar
                            className="schedule_now_calendar"
                            value={calendarValue}
                            onSelect={(newValue) => setCalendarValue(newValue)}
                            headerRender={({ value, onChange }) => {
                              const year = value.year();
                              const month = value.month();

                              const yearOptions = Array.from(
                                { length: 20 },
                                (_, i) => {
                                  const label = year - 10 + i;
                                  return { label, value: label };
                                }
                              );

                              const monthOptions = value
                                .localeData()
                                .monthsShort()
                                .map((label, index) => ({
                                  label,
                                  value: index,
                                }));

                              return (
                                <Flex
                                  gap={8}
                                  justify="space-between"
                                  align="center"
                                  style={{ marginTop: 8 }}
                                >
                                  <div className="calendarLeftTop">
                                    <Select
                                      size="small"
                                      popupMatchSelectWidth={false}
                                      value={year}
                                      options={yearOptions}
                                      onChange={(newYear) => {
                                        const now = value.clone().year(newYear);
                                        onChange(now);
                                      }}
                                      suffixIcon={<SelectArrow />}
                                    />
                                    <Select
                                      size="small"
                                      popupMatchSelectWidth={false}
                                      value={month}
                                      options={monthOptions}
                                      onChange={(newMonth) => {
                                        const now = value
                                          .clone()
                                          .month(newMonth);
                                        onChange(now);
                                      }}
                                      suffixIcon={<SelectArrow />}
                                    />
                                  </div>
                                  <div className="calendarRightTop">
                                    <Button
                                      onClick={() => {
                                        const newMonthValue = value
                                          .clone()
                                          .subtract(1, "month");
                                        onChange(newMonthValue);
                                      }}
                                      icon={<SelectArrow />}
                                      className="prevBtn"
                                    />
                                    <Button
                                      onClick={() => {
                                        const newMonthValue = value
                                          .clone()
                                          .add(1, "month");
                                        onChange(newMonthValue);
                                      }}
                                      icon={<SelectArrow />}
                                      className="nextBtn"
                                    />
                                  </div>
                                </Flex>
                              );
                            }}
                          />
                        </Col>
                        {/* <Col xs={24} md={12}>
                          <Calendar
                            value={nextMonthValue}
                            onSelect={(newValue) => {
                              // Update the state with the selected date from the second calendar
                              setValue(newValue);
                            }}
                          />
                        </Col> */}
                      </Row>
                    </Card>
                  </div>
                )}
              </Card>
            </Col>
          </Row>

          <div className="fixed_btm_card">
            <Card>
              <div className="centered">
                <Button
                  htmlType="button"
                  className="outlined-btn"
                  // onClick={() => navigate(`/tasks/${companyId}`)}
                  onClick={() => navigate(-1)}
                >
                  Cancel
                </Button>
                <div style={{ display: "flex", gap: "16px" }}>
                  {/* <Button
                    htmlType="button"
                    className="outlined-btn"
                    type="primary"
                    // onClick={saveAddMore}
                  >
                    Save & add one more
                  </Button> */}
                  <Button htmlType="submit" type="primary" className="mint-btn">
                    Create task
                  </Button>
                </div>
              </div>
            </Card>
          </div>
        </div>
      </Form>
    </FullPageLayout>
  );
}
